export const translate = (x: number, y: number) => {
  return `translate(${x} ${y})`;
};
